import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { HireCandidateContactViewComponent } from '../hire-candidate-contact-view/hire-candidate-contact-view.component';
import { HireNotesComponent } from '../hire-notes/hire-notes.component';
import { HireFilesComponent } from '../hire-files/hire-files.component';

@Component({
  selector: 'app-hire-slider-side-panel',
  imports: [HireCandidateContactViewComponent, HireNotesComponent, HireFilesComponent],
  templateUrl: './hire-slider-side-panel.component.html',
  styleUrl: './hire-slider-side-panel.component.scss',
  standalone:true
})
export class HireSliderSidePanelComponent {
  @Input() candidate:any
//  readonly isCollapsed = signal(false);
 isCollapsed:boolean=false
 isCollapsed2:boolean=false
 isCollapsed3:boolean=true;
 @Input() calledFrom: string;
 @Output() candidateUpdated = new EventEmitter<any>();

 ngOnInit() {
  console.log('candidate',this.candidate)
 }
}
